import React from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { API_BASE_URL } from '../services/api';

const CAD_VIEWER_BASE = '/cad/';

/**
 * Strona CAD dla projektu/oferty – pusty canvas z menu Mapuj/Pliki.
 * URL: /cad/:projectOrOfferId
 */
const CadProjectPage: React.FC = () => {
  const { projectOrOfferId } = useParams<{ projectOrOfferId: string }>();

  if (!projectOrOfferId) {
    return null;
  }

  const apiBase = (API_BASE_URL || '').replace(/\/$/, '');
  const viewerSrc = `${CAD_VIEWER_BASE}?projectId=${encodeURIComponent(projectOrOfferId)}${apiBase ? `&apiBase=${encodeURIComponent(apiBase)}` : ''}`;

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <iframe
        src={viewerSrc}
        title="Przeglądarka CAD"
        style={{
          width: '100%',
          height: '100%',
          border: 0,
          display: 'block',
        }}
      />
    </Box>
  );
};

export default CadProjectPage;
